module.exports = __webpack_public_path__ + "media/images/landing__bg-d59b3f649f784eb65447e4a5243b3c1d.jpg";